import React, { useEffect, useState, useMemo } from "react";
import { message, Table, Tooltip } from "antd";
import { ColumnsType } from "antd/es/table";
import { usePurchasePoModel } from "../purchasePoModel";
import { IPurchasePoDetail } from "../purchasePoType"
import YhTag from "@/components/YhTag";
import { useDictModel } from "@/views/base/dict/dictModel";
import { momentFormat, formatNum } from "@/utils/utils";
import useNavModel from "@/model/navModel";
import { tableSize } from "@/utils/constants";
import copy from "copy-to-clipboard";
import YhTootip from "@/components/YhTootip";
import { roleColumnModel } from "@/utils/roleColumn";
import useGlobalModel from "@/model/globalModel";

type statusType = {
    "purchase-status.create": string,
    "purchase.completely-io": string,
    "purchase-status.bill": string,
    "purchase.change": string,
    "purchase-status.write-off": string,

    [key: string]: any
}


export function DataTable() {
    const { dataSource, selectedRowKeys, pgCfg, descRows, loadData, descTotal, rowsDescTotal, setSelectedRowKeys, setDescRows, reset } = usePurchasePoModel();
    const { getTreeNodeName } = useDictModel();
    const { selectedNavId, replaceNav, findNav } = useNavModel();
    const { user: { roles } } = useGlobalModel();
    const { getRoleColumns } = roleColumnModel();

    const onLook = (code: string) => {
        let supplierEditKey = "11-2-3";
        replaceNav(
            selectedNavId,
            supplierEditKey,
            { id: code, mode: "look", },
            true
        );
    }

    useEffect(() => {
        loadData().then();
    }, [])

    const statusColor: statusType = {
        "purchase-status.create": "blue",
        "purchase.completely-io": "cyan",
        "purchase-status.bill": "green",
        "purchase.change": "red",
        "purchase-status.write-off": "geekblue",
    }

    const copyText = (e: any, str: string) => {
        e.stopPropagation();
        if (str) {
            copy(str);
            message.success("复制成功")
        }
    }
    const defaultColumns: ColumnsType<IPurchasePoDetail> = [
        {
            title: '序号',
            fixed: "left",
            width: 60,
            render: (t, r, i) => i + 1
        }, {
            title: '采购单号',
            width: 180,
            dataIndex: 'purchaseCode',
            render: (text: any, record: any) => <Tooltip placement="topLeft" title={<>
                <span style={{ cursor: "copy" }} onClick={(e) => copyText(e, text)}>采购单号：{text}</span><br />
                <span style={{ cursor: "copy" }} onClick={(e) => copyText(e, record.planCode ?? "")}>采购订单号：{record.planCode ?? '无'}</span>
            </>}><p className="ellipsis click-span" onClick={(e) => { e.stopPropagation(); onLook(text) }}>{text} {!!record.planCode && <span style={{ background: "orange", color: "white", padding: '0 2px' }}>转</span>}</p></Tooltip>,
        }, {
            title: '采购订单号',
            width: 150,
            dataIndex: 'planCode',
            render: (text: any) => <YhTootip text={text} style={{ width: 150 }} />,
        }, {
            title: '调拨单号',
            width: 180,
            dataIndex: 'transferOrder',
            render: (text: any) => <YhTootip text={text} style={{ width: 180 }} />,
        }, {
            title: '单据状态',
            width: 80,
            dataIndex: 'status',
            render: (text) => <YhTag color={statusColor[text]} text={getTreeNodeName(text)} />,
        }, {
            title: '支付状态',
            width: 80,
            dataIndex: 'payStatus',
            render: (text) => getTreeNodeName(text)
        }, {
            title: '采购类型',
            width: 100,
            dataIndex: 'purchaseTypeName',


        }, {
            title: '结算类型',
            width: 80,
            dataIndex: 'payType',
            render: (text) => getTreeNodeName(text)
        }, {
            title: '结算方式',
            width: 150,
            dataIndex: 'payMethodName',
            // render: (text: any) => <Tooltip placement="topLeft" title={text}><p className="ellipsis">{getTreeNodeName(text) ? getTreeNodeName(text) : text}</p></Tooltip>,
            render: (text: any, record: any) => <Tooltip placement="topLeft" title={record?.settleDetails?.[0]?.payMethodName ?? record?.settleDetails?.[0]?.accountName}><p className="ellipsis">{record?.settleDetails?.[0]?.payMethodName ?? record?.settleDetails?.[0]?.accountName}</p></Tooltip>,

        }, {
            title: '采购数量',
            width: 110,
            dataIndex: 'totalNum',
        }, {
            title: '到货数量',
            width: 80,
            dataIndex: 'arrivedNum',
        }, {
            title: '损坏数量',
            width: 80,
            dataIndex: 'damageTotalNum',
        }, {
            title: '入库数量',
            width: 80,
            dataIndex: 'stockIoNum',

        }, {
            title: '已付金额',
            width: 110,
            dataIndex: 'paidAmount',
            render: (text) => `￥${formatNum(text)}`
        }, {
            title: '退货数量',
            width: 80,
            dataIndex: 'returnTotalNum',
        }, {
            title: '发票类型',
            width: 160,
            dataIndex: 'invoiceTypeName',
        }, {
            title: '联系人',
            width: 150,
            dataIndex: 'contact',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '电话',
            width: 95,
            dataIndex: 'phone',
        }, {
            title: '制单员',
            width: 90,
            dataIndex: 'createUser',
        }, {
            title: '制单日期',
            width: 130,
            dataIndex: 'createTime',
            render: (text) => momentFormat(text)
        }, {
            title: '库管员',
            width: 90,
            dataIndex: 'storekeeper',
        }, {
            title: '入库日期',
            width: 130,
            dataIndex: 'stockIoTime',
            render: (text) => momentFormat(text)
        }, {
            title: '结算员',
            width: 90,
            dataIndex: 'reckoner',
        }, {
            title: '结算日期',
            width: 130,
            dataIndex: 'settleTime',
            render: (text) => momentFormat(text)
        }, {
            title: '核销日期',
            width: 130,
            dataIndex: 'writeOffTime',
            render: (text) => momentFormat(text)
        }, {
            title: '作废原因',
            width: 120,
            dataIndex: 'cancelReason',
        }, {
            title: '备注',
            width: 160,
            dataIndex: 'note',
        }, {
            title: '商品类型',
            width: 80,
            dataIndex: 'materialTypeName',
        }, {
            title: '采购订单号',
            width: 120,
            dataIndex: 'planCode',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '调入单号',
            width: 180,
            dataIndex: 'allocationCode',
            render: (text: any) => <YhTootip text={text} />,
        }, {
            title: '供应商',
            width: 160,
            dataIndex: 'supplierName',
            render: (text: any) => <YhTootip text={text} />,
            fixed: "right"
        }, {
            title: '采购金额',
            width: 140,
            dataIndex: 'payableAmount',
            fixed: "right",
            render: (text) => `￥${formatNum(text)}`
        }, {
            title: '打印次数',
            width: 80,
            fixed: "right",
            align: "center",
            dataIndex: 'printingTimes',
        },
        {
            title: '所属站点',
            width: 250,
            fixed: "right",
            dataIndex: 'shopName',
            render: (text: any) => <YhTootip text={text} style={{ width: 250 }} />,
        }
    ];

    const roleColumns = useMemo(() => {
        //根据可视化配置处理需要展示相关列
        const params = { "code": "purchase", "roleCodes": roles };
        return getRoleColumns("purchase", "主单", defaultColumns, params);
    }, [roles, dataSource]);
    //点击行选高亮
    const onRow = (record: IPurchasePoDetail) => {
        let { id } = record as { id: string }
        let findIndexDesc = descRows.findIndex((item) => (item.id === id))
        let newDescRows = [...descRows];
        let newSelectedRowKeys = [...selectedRowKeys];

        if (findIndexDesc === -1) {
            //统计数据
            newDescRows.push(record)
            setDescRows(newDescRows)
            //表格选中行Key值
            newSelectedRowKeys.push(id);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            //统计数据
            newDescRows.splice(findIndexDesc, 1);
            setDescRows(newDescRows);
            //表格选中行Key值
            newSelectedRowKeys.splice(findIndexDesc, 1);
            setSelectedRowKeys(newSelectedRowKeys);
        }
    };
    const onRightClick = (record: IPurchasePoDetail) => {
        setDescRows([record])
        setSelectedRowKeys([record.id as string])
    }
    return (
        <Table
            bordered
            style={{ cursor: "pointer" }}
            size={tableSize}
            rowKey={record => record.id as string}
            rowSelection={{
                type: "checkbox",
                onChange: (selectedRowKeys: React.Key[], selectedRows: IPurchasePoDetail[]) => {
                    setSelectedRowKeys(selectedRowKeys as string[]);
                    setDescRows(selectedRows)
                },
                selectedRowKeys
            }}
            columns={roleColumns}
            dataSource={dataSource}
            pagination={{
                showSizeChanger: true,
                ...pgCfg,
                defaultPageSize: 25,
                pageSizeOptions: ['15', '25', '50', '100', '200', '500'],
                position: ["bottomRight"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize }).then();
                }
            }}
            onRow={record => ({
                // onClick: () => onRow(record.id as string),
                onClick: () => onRow(record),
                onContextMenu: (e) => {
                    e.preventDefault();
                    // setSelectedRowKeys([record.id as string]);
                    onRightClick(record)
                }

            })}
            scroll={{ x: 'max-content', y: 'calc(100vh - 370px)' }}
            summary={() => (
                <Table.Summary fixed>
                    <Table.Summary.Row className="table-total-box">
                        <Table.Summary.Cell index={0}>
                            <div className="title">合计</div>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={1} />
                        <Table.Summary.Cell index={2} />
                        <Table.Summary.Cell index={3} />
                        <Table.Summary.Cell index={4} />
                        <Table.Summary.Cell index={5} />
                        <Table.Summary.Cell index={6} />
                        <Table.Summary.Cell index={7} />
                        <Table.Summary.Cell index={8} />
                        <Table.Summary.Cell index={9} />
                        <Table.Summary.Cell index={10} >
                            <span className="red">{selectedRowKeys.length === 0 ? descTotal.totalNum : rowsDescTotal.totalNum}</span>
                        </Table.Summary.Cell>
                        <Table.Summary.Cell index={11} />
                        <Table.Summary.Cell index={12} />
                        <Table.Summary.Cell index={13} />
                        {/* >
                            <span className="red">{formatNum(selectedRowKeys.length === 0 ? descTotal.paidAmount : rowsDescTotal.paidAmount)}</span>
                        </Table.Summary.Cell> */}
                        <Table.Summary.Cell index={14} />
                        <Table.Summary.Cell index={15} />
                        <Table.Summary.Cell index={16} />
                        <Table.Summary.Cell index={17} />
                        <Table.Summary.Cell index={18} />
                        <Table.Summary.Cell index={19} />
                        <Table.Summary.Cell index={20} />
                        <Table.Summary.Cell index={21} />
                        <Table.Summary.Cell index={22} />
                        <Table.Summary.Cell index={23} />
                        <Table.Summary.Cell index={24} />
                        <Table.Summary.Cell index={25} />
                        <Table.Summary.Cell index={26} />
                        <Table.Summary.Cell index={27} />
                        <Table.Summary.Cell index={28} />
                        <Table.Summary.Cell index={29} />
                        <Table.Summary.Cell index={30} />
                        <Table.Summary.Cell index={31} />
                        {/* >
                            <span className="red">{formatNum(selectedRowKeys.length === 0 ? descTotal.totalAmount : rowsDescTotal.totalAmount)}</span>
                        </Table.Summary.Cell> */}
                        <Table.Summary.Cell index={32} />
                        <Table.Summary.Cell index={33} />
                    </Table.Summary.Row>
                </Table.Summary>
            )}
        />
    )
}
